import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import Dialog from "../Common/Dialog";
import RHFTextField from "../Common/RHFComponents/RHFTextField";
import RHFAutocomplete from "../Common/RHFComponents/RHFAutocomplete";
import RHFQuillEditor from "../Common/RHFQuillEditor";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const SystemPromptFormDialog = ({
  open,
  isEditMode,
  onClose,
  onSuccess,
  defaultValues,
  categoryOptions,
}) => {
  const validationSchema = Yup.object({
    name: Yup.string().required("System Prompt Name is required"),
    category: Yup.array()
      .min(1, "At least one category is required")
      .of(
        Yup.object().shape({
          value: Yup.string().required(),
          label: Yup.string().required(),
        })
      ),
  });

  const { control, handleSubmit, reset } = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    reset(defaultValues); // <-- Key step
  }, [defaultValues, reset]);

  const onSubmit = async (values) => {
    await onSuccess(values);
    onClose();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Dialog
        isOpen={open}
        cancelSubmitHandle={onClose}
        handleClose={onClose}
        okSubmitHandle={handleSubmit(onSubmit)}
        okBtnText={isEditMode ? "Update" : "Submit"}
        title={
          <Typography variant="h6">
            {isEditMode ? "Edit System Prompt" : "Add System Prompt"}
          </Typography>
        }
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <RHFTextField
              name="name"
              label="System Prompt Name"
              placeholder="Enter System Prompt Name"
              control={control}
              focused
            />
          </Grid>
          <Grid item xs={12}>
            <RHFAutocomplete
              name="category"
              label="Category"
              multiple
              freeSolo
              control={control}
              options={categoryOptions}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              isOptionEqualToValue={(option, value) =>
                option.value ===
                (typeof value === "string" ? value : value?.value)
              }
            />
          </Grid>
          <Grid item xs={12}>
            <RHFQuillEditor
              label="System Prompt Content"
              required
              defaultPrompt="### System Prompt Example"
              name="prompt"
              control={control}
            />
          </Grid>
        </Grid>
      </Dialog>
    </form>
  );
};

export default SystemPromptFormDialog;
